import { Components } from '../../../styles';

export const accordionTheme = {
  MuiAccordion: {
    styleOverrides: {
      root: {
        '&.BpCard-prominent': {
          backgroundColor: '#F4F3F7'
        }
      }
    }
  }
} satisfies Components;
